import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
//import { GlobalContext } from '../Contexts/GlobalContext';
import TextField from '@material-ui/core/TextField';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';



export default function OpeningTimes(props) {
    const [translateGui] = useGuiTranslations();
    const classes = useStyles();

    const updateWorkingHoursSpec = (index, openClose, newValue) => {
        let newWorkingHours = [...props.workingHoursSpec];
        if (openClose == 'open') {
            newWorkingHours[index].opens = newValue;
        }

        if (openClose == 'close') {
            newWorkingHours[index].closes = newValue;
        }
        //console.log(newWorkingHours);
        props.setWorkingHoursSpec(newWorkingHours);
    }

    return (
        <div className={classes.root}>
            <div style={{margin: '30px 0 10px 0'}}>Opening Times</div>
            <table style={{marginBottom: '30px'}}>
                <tbody>
                    {
                        props.workingHoursSpec.map(
                            (spec, index) =>
                                <tr key={index}>
                                    <td>
                                        {
                                            
                                            <React.Fragment>
                                                {capitalizeFirstLetter(translateGui(74+index))}
                                            </React.Fragment>
                                            
                                        }
                                    </td>
                                    <td>
                                        <TextField
                                            id="time"
                                            label="Open"
                                            type="time"
                                            //defaultValue={spec.opens}
                                            value={spec.opens}
                                            className={classes.textField}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                step: 300, // 5 min
                                            }}
                                            onChange={(e) => updateWorkingHoursSpec(index, 'open', e.target.value)}
                                        />

                                    </td>
                                    <td>
                                        <TextField
                                            id="time"
                                            label="Close"
                                            type="time"
                                            value={spec.closes}
                                            className={classes.textField}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                step: 300, // 5 min
                                            }}
                                            onChange={(e) => updateWorkingHoursSpec(index, 'close', e.target.value)}

                                        />

                                    </td>
                                </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    )
}

const useStyles = makeStyles({
    root: {
    },
    textField: {


    },
});